import { useLoadRows } from '@/features/query-builder/hooks';
import { useAppDispatch } from '@/store/hooks';
import React from 'react';
import { latestRequestIds } from '@/features/query-builder/latestRequestIds';
import {
  rowsCountStopLoading,
  rowsStartLoading,
  rowsStopLoading,
  startQueryTimer,
} from '@/features/query-builder/queryBuilderSlice';

/**
 * This hook fixes UI state when we end up with a long-running query
 * and navigate back to previous steps - so we reset loading state and display
 * data table/rows results properly.
 */
export const useResetRowsLoading = () => {
  const { requestId, isFetching } = useLoadRows();
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    if (
      requestId &&
      latestRequestIds.rows &&
      requestId !== latestRequestIds.rows
    ) {
      if (isFetching) {
        dispatch(rowsStartLoading());
        dispatch(startQueryTimer());
      } else {
        dispatch(rowsStopLoading());
        dispatch(rowsCountStopLoading());
      }

      latestRequestIds.rows = requestId;
    }
  }, [requestId, isFetching]);
};
